module.exports = __webpack_public_path__ + "static/media/built-around-you.f77c0fad.svg";